// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"a843f338","598":"e5bebdfe"}[chunkId] + ".css";
};